import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.css'],
})
export class BudgetComponent implements OnInit {
  // FormGroup for budget
  budget: FormGroup;
  private saveApi = environment.url + 'coe/budget/save';
  private getApi = environment.url + 'coe/budget/get?id=';
  // API endpoint to save budget data
  constructor(
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.budget = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      budgetEstablishmentEquipment: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetOfficeEquipment: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetNonRecurryingTotal: [''],
      budgetRecurryingvp: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      budgetRecurryingIncubationpl: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingMarketingpl: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingProjectAssociate: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingUtility: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingMarketing: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingNetworking: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingAdministrativeOverhead: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingConsumables: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingMiscellaneous: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetRecurryingTotal: [''],
      budgetNonRecurryingAndRecurryingTotal: [''],
    });
  }
  // Flag to control the visibility of the form
  showForm: boolean = false;
  get setting() {
    return this.budget.controls;
  }

  getValue: any = {};
  disableBtn: boolean;
  getId: any;
  // ID of the budget entry
  ngOnInit(): void {
    this.getDataApi();
  }
  // Initialize the component and fetch budget data
  resetForm(): void {
    if (this.getId == 0) {
      this.budget.reset();
    }
  }
  // Reset the form if no budget entry exists
  calculateTotal1(): void {
    const year1 =
      parseFloat(this.budget.get('budgetEstablishmentEquipment')?.value) || 0;
    const year2 =
      parseFloat(this.budget.get('budgetOfficeEquipment')?.value) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget.get('budgetNonRecurryingTotal')?.setValue(total);
    this.calculateGrandTotal();
  }
  // Calculate the total for non-recurring budget items
  // and update the total field in the form
  calculateTotal2(): void {
    const year1 = parseFloat(this.budget.get('budgetRecurryingvp')?.value) || 0;
    const year2 =
      parseFloat(this.budget.get('budgetRecurryingIncubationpl')?.value) || 0;
    const year3 =
      parseFloat(this.budget.get('budgetRecurryingMarketingpl')?.value) || 0;
    const year4 =
      parseFloat(this.budget.get('budgetRecurryingProjectAssociate')?.value) ||
      0;
    const year5 =
      parseFloat(this.budget.get('budgetRecurryingUtility')?.value) || 0;
    const year6 =
      parseFloat(this.budget.get('budgetRecurryingMarketing')?.value) || 0;
    const year7 =
      parseFloat(this.budget.get('budgetRecurryingNetworking')?.value) || 0;
    const year8 =
      parseFloat(
        this.budget.get('budgetRecurryingAdministrativeOverhead')?.value
      ) || 0;
    const year9 =
      parseFloat(this.budget.get('budgetRecurryingConsumables')?.value) || 0;
    const year10 =
      parseFloat(this.budget.get('budgetRecurryingMiscellaneous')?.value) || 0;
    const total = parseFloat(
      (
        year1 +
        year2 +
        year3 +
        year4 +
        year5 +
        year6 +
        year7 +
        year8 +
        year9 +
        year10
      ).toFixed(2)
    );
    this.budget.get('budgetRecurryingTotal')?.setValue(total);
    this.calculateGrandTotal();
  }
  // Calculate the total for recurring budget items
  // and update the total field in the form
  calculateGrandTotal(): void {
    const total1 =
      parseFloat(this.budget.get('budgetNonRecurryingTotal')?.value) || 0;
    const total2 =
      parseFloat(this.budget.get('budgetRecurryingTotal')?.value) || 0;
    const grandTotal = parseFloat((total1 + total2).toFixed(2));
    this.budget
      .get('budgetNonRecurryingAndRecurryingTotal')
      ?.setValue(grandTotal);
  }
  //  Calculate the grand total of both non-recurring and recurring budget items
  // and update the total field in the form
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        this.getId = data.id;
        this.showForm = data.edit === false;
        if (data.responseStatus != 'Failed') {
          this.budget.patchValue(data);
        }
      });
  }
  // Fetch budget data from the API and populate the form
  // If the data is not found, reset the form
  cancleBtn() {
    this.showForm = false;
    this.budget.reset();
  }
  // Cancel the form and reset the visibility flag
  // Prevent the Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
  // Prevent the Enter key from submitting the form
  // Save the budget data to the API
  @Input() parent: any;

  saveBtn() {
    const getform = this.budget.value;
    if (this.budget.invalid) {
      this.budget.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      getform.applicationId = sessionStorage.getItem('applicationId');
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          if (this.parent) {
            this.parent.navigateToTab(2);
          }
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
    }
  }
  // Save the budget data to the API
  previous() {
    this.parent.navigateToTab(0);
  }
}
